<template>
    <div class="view view-challenge-select-user">
        <HeaderChallengeSelectUser
            textH1="Meydan Okuma"
            textDesc="Meydan okuyacağın kişiyi seç." />
        <InputChallengeSelectUserUsername
            @newInput="this.$store.state.envDev ? searchUser() : searchUserApi()" />
        <ResultChallengeSelectUserUsername
            v-if="showResultReport"
            :errorInvOptions="errorInvOptions" />
        <Preloader
            v-if="showPreloader"
            preloaderText="Yükleniyor..." />
        <OrderbarChallengeSelectUser />
        <div
            v-if="showActiveUsersList"
            class="view-challenge-select-user__active-users-list">
            <CardChallengeSelectUserItem
                v-for="userItem in orderedActiveUserItems" :key="userItem.id"
                :userItem="userItem"
                @selectUser="selectUser" />
        </div>
        <div
            v-if="showSearchedUsersList"
            class="view-challenge-select-user__searched-users-list">
            <CardChallengeSelectUserItem
                v-for="userItem in orderedSearchedUserItems" :key="userItem.id"
                :userItem="userItem"
                @selectUser="selectUser" />
        </div>
        <CardEmptyStateChallengeSelectUser
            v-if="showEmptyState" />
        <CardErrorStateChallengeSelectUser
            v-if="showErrorState" />
        <ModalChallengeSelectUser
            v-if="showModal"
            @cancelSelection="cancelSelection" />

        <BtnChallenge
            @click="routeChallengeSelectUser" />
        <BtnPracticeModes
            @click="routePracticeModes" />
        <Navbar />
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    import HeaderChallengeSelectUser            from '@/components/HeaderChallengeSelectUser.vue';
    import InputChallengeSelectUserUsername     from '@/components/InputChallengeSelectUserUsername.vue';
    import ResultChallengeSelectUserUsername    from '@/components/ResultChallengeSelectUserUsername.vue';
    import Preloader                            from '@/components/Preloader.vue';
    import OrderbarChallengeSelectUser          from '@/components/OrderbarChallengeSelectUser.vue';
    import CardChallengeSelectUserItem          from '@/components/CardChallengeSelectUserItem.vue';
    import CardEmptyStateChallengeSelectUser    from '@/components/CardEmptyStateChallengeSelectUser.vue';
    import CardErrorStateChallengeSelectUser    from '@/components/CardErrorStateChallengeSelectUser.vue';
    import ModalChallengeSelectUser             from '@/components/ModalChallengeSelectUser.vue';
    import BtnChallenge                         from '@/components/BtnChallenge.vue';
    import BtnPracticeModes                     from '@/components/BtnPracticeModes.vue';
    import Navbar                               from '@/components/Navbar.vue';

    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        components: {
            HeaderChallengeSelectUser,
            InputChallengeSelectUserUsername,
            ResultChallengeSelectUserUsername,
            Preloader,
            OrderbarChallengeSelectUser,
            CardChallengeSelectUserItem,
            CardEmptyStateChallengeSelectUser,
            CardErrorStateChallengeSelectUser,
            ModalChallengeSelectUser,
            BtnChallenge,
            BtnPracticeModes,
            Navbar,
        },

        data(){
            return {
                showPreloader: false,
                showModal: false,
                previousController: null,
                errorInvOptions: false,
            };
        },

        computed: {
            showResultReport(){
                let inputUsername     = this.$store.state.input.challengeSelectUser.username;
                if(this.showPreloader){
                    return false;
                }
                if(inputUsername){
                    return true;
                }
                return false;
            },

            showActiveUsersList(){
                let inputUsername     = this.$store.state.input.challengeSelectUser.username;
                let searchedUserItems = this.$store.state.response.challengeSelectUser.searchedUserItems;
                if(this.showPreloader){
                    return false;
                }
                else if(inputUsername){
                    return false;
                }
                return true;
            },

            showSearchedUsersList(){
                let searchedUserItems = this.$store.state.response.challengeSelectUser.searchedUserItems;
                if(this.showPreloader){
                    return false;
                }
                else if(searchedUserItems.length > 0){
                    return true;
                }
                return false;
            },

            showEmptyState(){
                let inputUsername     = this.$store.state.input.challengeSelectUser.username;
                let searchedUserItems = this.$store.state.response.challengeSelectUser.searchedUserItems;
                if(this.showPreloader){
                    return false;
                }
                else if(inputUsername && searchedUserItems.length === 0 && this.errorInvOptions === false){
                    return true;
                }
                return false;
            },

            showErrorState(){
                let inputUsername = this.$store.state.input.challengeSelectUser.username;
                if(this.showPreloader){
                    return false;
                }
                else if(inputUsername && this.errorInvOptions){
                    return true;
                }
                return false;
            },

            orderedActiveUserItems(){
                let sortedUserItems = null;
                let selectedOrdertag = this.$store.state.selectedOrdertagChallengeSelectUser;
                let activeUserItems = this.$store.state.response.challengeSelectUser.activeUserItems;

                if(selectedOrdertag.type === 'last-seen'){
                    sortedUserItems = activeUserItems.toSorted((a, b) => {
                        return a.lastActive - b.lastActive;
                    });
                    return sortedUserItems.toReversed();
                }
                else if(selectedOrdertag.type === 'alphabetic'){
                    sortedUserItems = activeUserItems.toSorted((a, b) => {
                        return a.username.localeCompare(b.username, 'tr');
                    });
                    return sortedUserItems;
                }
                else if(selectedOrdertag.type === 'best-rank'){
                    sortedUserItems = activeUserItems.toSorted((a, b) => {
                        return a.rank - b.rank;
                    });
                    return sortedUserItems;
                }
            },

            orderedSearchedUserItems(){
                let sortedUserItems = null;
                let selectedOrdertag = this.$store.state.selectedOrdertagChallengeSelectUser;
                let searchedUserItems = this.$store.state.response.challengeSelectUser.searchedUserItems;

                if(selectedOrdertag.type === 'last-seen'){
                    sortedUserItems = searchedUserItems.toSorted((a, b) => {
                        return a.lastActive - b.lastActive;
                    });
                    return sortedUserItems.toReversed();
                }
                else if(selectedOrdertag.type === 'alphabetic'){
                    sortedUserItems = searchedUserItems.toSorted((a, b) => {
                        if(a.username < b.username){
                            return -1;
                        }
                        if(a.username > b.username){
                            return 1;
                        }
                        return 0;
                    });
                    return sortedUserItems;
                }
                else if(selectedOrdertag.type === 'best-rank'){
                    sortedUserItems = searchedUserItems.toSorted((a, b) => {
                        return a.rank - b.rank;
                    });
                    return sortedUserItems;
                }
            }
        },

        methods: {
            searchUser(){
                if(this.previousController){
                    this.previousController.abort('VIEW_CHALLENGE_SELECT_USER/SEARCH_USER::ABORTED');
                }

                this.showPreloader = true;
                this.errorInvOptions = false;
                this.previousController = new AbortController();

                fetch(this.$store.state.jsonServer.challengeUserSearchValid, {
                    method: 'GET',
                    signal: this.previousController.signal,
                })
                .then(async response => {
                    if(response.url.includes('inv-options')){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(searchedUserItems => {
                    this.$store.commit('setChallengeSelectUserSearchedUserItems', searchedUserItems);
                    this.showPreloader = false;
                })
                .catch(err => {
                    if(typeof err === 'string' && err.includes('ABORTED')){
                        console.log(err);
                        return true;
                    }
                    else if(err.code === 'CHALLENGE_USER_SEARCH_MODEL/USER_SEARCH::INV_USER_SEARCH_OPTIONS'){
                        console.error(`VIEW_CHALLENGE_SELECT_USER/SEARCH_USER::API_ERROR_01`);
                        this.errorInvOptions = true;
                    }
                    this.showPreloader = false;
                });
            },

            searchUserApi(){
                if(this.previousController){
                    this.previousController.abort('VIEW_CHALLENGE_SELECT_USER/SEARCH_USER::ABORTED');
                }

                this.showPreloader = true;
                this.errorInvOptions = false;
                this.previousController = new AbortController();
                let requestBody = {
                    username: this.$store.state.input.challengeSelectUser.username
                };

                fetch(this.$store.state.api.challengeUserSearch, {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    body: `userSearchOptions=${JSON.stringify(requestBody)}`,
                    signal: this.previousController.signal,
                })
                .then(async response => {
                    if(response.status !== 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(searchedUserItems => {
                    this.$store.commit('setChallengeSelectUserSearchedUserItems', searchedUserItems);
                    this.showPreloader = false;
                })
                .catch(err => {
                    if(err.code === 'CHALLENGE_USER_SEARCH_MODEL/USER_SEARCH::INV_USER_SESSION'){
                        this.$foneturkError({
                            text: this.$t(`error.api.challengeUserSearch.${err.code}`),
                            didClose: () => {
                                this.$router.push('/login');
                            }
                        });
                        return true;
                    }
                    else if(err.code === 'CHALLENGE_USER_SEARCH_MODEL/USER_SEARCH::INV_USER_SEARCH_OPTIONS'){
                        this.$foneturkError({
                            text: this.$t(`error.api.challengeUserSearch.${err.code}`),
                        });
                        this.showPreloader = false;
                        this.errorInvOptions = true;
                    }
                });
            },

            clearInput(){
                this.errorInvOptions = false;
            },

            selectUser(userItem){
                this.$store.commit('setInputChallengeSelectUserSelectedUser', userItem);
                this.showModal = true;
            },

            cancelSelection(){
                this.showModal = false;
                this.$store.commit('setInputChallengeSelectUserSelectedUser', {});
            },

            routeChallengeSelectUser(){
                this.$router.push('/challenge/select-user');
            },

            routePracticeModes(){
                this.$router.push('/practice-modes');
            },
        },

        mounted(){
            if(this.$store.state.envDev){
                this.showPreloader = true;
                fetch(this.$store.state.jsonServer.challengeUsersActive)
                .then(response => response.json())
                .then(activeUserItems => {
                    console.log(activeUserItems);
                    this.$store.commit('setChallengeSelectUserActiveUserItems', activeUserItems);
                    this.showPreloader = false;
                });
            }
            else{
                this.showPreloader = true;
                fetch(this.$store.state.api.challengeUsersActive, {
                    method: 'GET',
                    credentials: 'include'
                })
                .then(async response => {
                    if(response.status !== 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(activeUserItems => {
                    this.$store.commit('setChallengeSelectUserActiveUserItems', activeUserItems);
                    this.showPreloader = false;
                })
                .catch(err => {
                    this.showPreloader = false;
                    if(err.code === 'CHALLENGE_USERS_ACTIVE_MODEL/USERS_ACTIVE::INV_USER_SESSION'){
                        this.$foneturkError({
                            text: this.$t(`error.api.challengeUsersActive.${err.code}`),
                            didClose: () => {
                                this.$router.push('/login');
                            }
                        });
                        return true;
                    }
                    this.$foneturkError({
                        text: this.$t('error.default')
                    })
                });
            }
        }
    };
</script>

<style scoped src="@/css/views/view-challenge-select-user.css"></style>